import SEO from "../../components/Common/SEO";
import CTASection from "../Home/CTABanner";
import FAQSection from "../Home/FAQSection";
import StatsSection from "../Home/StatsSection";
import WhyChooseUs from "../Home/WhyChooseUs";
import AboutHero from "./AboutHero";
import CustomerPromise from "./CustomerPromise";
import OurCommitment from "./OurCommitment";
import OurProcess from "./OurProcess";
import OurStory from "./OurStory";
import ServiceShowcase from "./ServiceShowcase";
import WhatWeClean from "./WhatWeClean";

const About = () => {
  return (
    <>
      <SEO page="about" />
      <AboutHero />
      <OurStory />
      <OurProcess />
      <ServiceShowcase />
      <WhatWeClean />
      <OurCommitment />
      <CustomerPromise />
      <StatsSection />
      <WhyChooseUs />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default About;
